// styled-components用
export const mq = {
  xs: 'max-width: 479px',
  sm: 'min-width: 480px',
  md: 'min-width: 768px',
  lg: 'min-width: 1024px',
  xl: 'min-width: 1200px',
};